import React from 'react'
import PropTypes from 'prop-types'
import { formatToCPF } from 'brazilian-values'

import moment from 'moment'
import Colors from 'utils/Colors'
import styles from './styles'


function UnlockedTable(props) {
  const { tableData } = props
  const classes = styles()

  return (
    <div>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>ID da Requisição</th>
            <th>Data/hora do Evento</th>
            <th>CPF</th>
            <th>Evento</th>
            <th>Notas</th>
          </tr>
        </thead>
        <tbody>
          {tableData.length === 0 &&
            <tr key="-1">
              <td colSpan={8}>Nenhum registro encontrado.</td>
            </tr>
          }
          {tableData.map((item) => (
            <tr key={item.audit_event_id}>
              <td>
                {item.audit_event_id}
              </td>
              <td>
                {item.timestamp ? moment(item.timestamp).format('DD/MM/YYYY HH:mm') : ''}
              </td>
              <td>
                {formatToCPF(item.cpf)}
              </td>
              <td>
                <strong style={{ color: item.event_type === 'block' ? Colors.reproved : Colors.darkBlue }}>{item.event_type === 'block' ? 'Bloqueio' : 'Desbloqueio manual'}</strong>
              </td>
              <td>
                {item.reason}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

UnlockedTable.propTypes = {
  tableData: PropTypes.array.isRequired,
}

export default UnlockedTable
